import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignKeywordParams from './CampaignKeywordParams';

export type TagsInputValue = any[]

const mapStateToProps = (state, { t }) => {
  const campaignKeywordParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.campaign_keyword_params || [];
  const globalCampaignKeywordParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.campaign_keyword_params || []
  )
    .map(
      element => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalCampaignKeywordParams,
    ...campaignKeywordParams,
  ];

  return {
    globalAndAppTrackerSettings,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(CampaignKeywordParams));
